import styled from 'styled-components';

export const CityText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  color: white;
`;

export const FlightIcon = styled.span`
  position: absolute;
  left: 6.25%;
  right: -6.25%;
  top: 100%;
  bottom: -85.71%;

  background: #0b69e3;
  transform: rotate(-90deg);
`;

export const Price = styled.span`
  font-weight: 500;
  font-style: normal;

  line-height: 15px;
  text-align: center;
  color: #0b69e3;
`;

export const CityInfoWrapper = styled.div`
  box-shadow: 0px 4px 10px rgba(195, 187, 200, 0.4);
  border-radius: 4px;
  color: white;
  text-align: center;
`;

export const toolTipWrapper = styled.div`
  color: #ffffff;
  .tooltiptext {
    background-color: #141823; //black;

    font-style: normal;
    font-weight: 500;

    line-height: 15px;
    text-align: center;
    border-radius: 6px;
    padding: 6px 6px;
    position: relative;
    z-index: 1;
  }
  .tooltiptext::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #141823 transparent transparent transparent;
  }
`;
